// Records which module a signed-in user is looking at. Fire-and-forget: a
// failed beacon must never break the page it is measuring.
export const trackModuleView = async (apiFetch, module) => {
  try {
    await apiFetch("/api/analytics/event", {
      method: "POST",
      body: JSON.stringify({ module }),
    });
  } catch (error) {
    console.debug("analytics: could not record module view", error);
  }
};
